import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getChallenges, joinChallenge } from "../../redux/data/dataActions";
import { setSelectFavTeamModalOpen, setShowNotification, setChallengesLoading, setJoiningChallenge } from "../../redux/data/dataSlice";
import ToastNotification from "../toastNotification.jsx";
import IDlogo from "../../assets/images/NBAID.svg";
import Gift from "../../assets/images/gift.svg";
import Clock from "../../assets/images/clock.svg";
import ArrowRight from "../../assets/images/arrow-right-white.svg";
import BlueCheck from "../../assets/images/blue-check.svg";
import ClearCheck from "../../assets/images/clear-check.svg";
import LoadingGif from "../../assets/images/loader.gif";
import SeeAll from "../../assets/images/seeall.svg";
import "../../assets/css/challenges.css";

function ChallengeCard(props) {
    console.log(props, "card");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pctCompleted = props && props.challenge && props.challenge.activities && props.challenge.activities.length > 0 ?
        props.challenge.activities.filter(activity => activity.activityHistory && activity.activityHistory.length > 0).length / props.challenge.activities.length : 0;
    const challengeJoined = props && props.challenge && props.challenge.challengeHistory && props.challenge.challengeHistory.length > 0;
    const challengeEarned = challengeJoined && pctCompleted === 1;
    const isActivityComplete = activity => activity && activity.activityHistory && activity.activityHistory.length > 0;
    const showJoinedChallengeNotif = useSelector(state => state.data.showNotification);
    const notifBody = useSelector(state => state.data.notificationBody);
    const challengeDataLoading = useSelector(state => state.data.challengesLoading);
    const joiningChallengeState = useSelector(state => state.data.joiningChallenge);
    const [challengeLoading, setChallengeLoading] = useState(false);
    const notif = { title: "Success", subtitle: "You've successfully joined the " + props.challenge.title + "." };
    const isActivityParentComplete = activity => {
        if (activity && activity.activityParent && props.challenge && props.challenge.activities && props.challenge.activities.length > 0) {
            const parentActivity = props.challenge.activities.find(act => act.activityId === activity.activityParent);
            return parentActivity && parentActivity.activityHistory && parentActivity.activityHistory.length > 0;
        }
        return false;
    }

    const endDaysMessage = () => {
        if (props && props.challenge && props.challenge.date_end) {
            let daysLeft = (((((props.challenge.date_end * 1000 - Date.now()) / 1000) / 60) / 60) / 24).toFixed(0);
            if (daysLeft >= 2) {
                return `${daysLeft} Days Left`;
            } else {
                if (daysLeft === 1) {
                    return `1 Day Left`;
                } else {
                    return `Ends Today`;
                }
            }
        }
        return "";
    };

    const joinChallengeClick = () => {
        setChallengeLoading(true);
        dispatch(setJoiningChallenge(props.challenge.id));
        dispatch(setChallengesLoading(true));
        dispatch(joinChallenge(props.challenge.id));
        dispatch(getChallenges("challenges"));
    };

    const renderActiveCTA = activity => {
        if (activity.activityCta === "Choose") {
            return <div onClick={() => {dispatch(setSelectFavTeamModalOpen(true));}}>
                {activity.activityCta}
            </div>;
        }
        return <a href={activity.activityUrl} target="_blank" rel="noreferrer"
            data-track="click"
            data-id="nba:membership-hub:challenges:tasks:cta"
            data-type="cta"
            data-text={activity.activityCta}
            data-content={props.challenge.title}
        >{activity.activityCta}</a>
    };

    useEffect(() => {
        if (joiningChallengeState === props.challenge.id || challengeDataLoading) {
            setChallengeLoading(true);
        } else {
            setChallengeLoading(false);
        }
    }, [joiningChallengeState, challengeDataLoading, props.challenge]);

    return (
        <div id={props.challenge.id} className="challenge-card" style={{ backgroundImage: `url(${props.challenge.extra_data.BackgroundImage})` }}>
            <div className="challenge-body">
                <div className={`challenge-details${challengeEarned ? " earned" : ""}`} onClick={() => {
                    if (pctCompleted === 1) {
                        navigate(`/challenges/${props.challenge.id}`);
                    }
                }}>
                    <div className="top-img-row">
                        <img className="nbaid-logo" src={IDlogo} />
                    </div>
                    <div className="challenge-header">
                        <div className="challenge-image">
                            {challengeJoined ?
                                <div className="earned-background" style={{ backgroundImage: `url(${props.challenge.image})` }}>
                                    <div className="unearned-image" style={{ height: `calc(158px * ${1 - pctCompleted})` }}>
                                        <img src={props.challenge.image} />
                                    </div>
                                </div>
                                :
                                <div className="earned-background" style={{ backgroundImage: `url(${props.challenge.image})` }}>
                                    <div className="unearned-image" style={{ height: "158px" }}>
                                        <img src={props.challenge.image} />
                                    </div>
                                </div>
                            }
                        </div>
                        {props.challenge.extra_data.Partner_logo && <div className="presented-by">
                            Presented by
                            <img className="sponsor-logo" src={props.challenge.extra_data.Partner_logo} />
                        </div>}
                    </div>
                    <div className="challenge-title">{props.challenge.title}</div>
                    <div className="challenge-completion">
                        Track Your Progress
                        <div className="time-left"><img src={Clock} alt="" />{endDaysMessage()}</div>
                    </div>
                    <div className="challenge-progress">
                        <div className={`percent-completed${challengeJoined ? "" : " not-joined"}${pctCompleted === 1 ? " complete" : pctCompleted === 0 ? " zero" : ""}`} style={{ width: `${pctCompleted * 100}%` }}>{(pctCompleted * 100).toFixed(0)}%</div>
                    </div>
                    <div className="challenge-desc" dangerouslySetInnerHTML={{__html: props.challenge.description}} />
                    { pctCompleted === 1 &&
                        <div className="view-details-cta">Share Your Badge <img alt="See All" src={SeeAll}></img></div> }
                </div>
                <div className="challenge-activities">
                    {!challengeJoined && !challengeLoading && <div className="join-challenge">
                        <button className="join-challenge-cta" onClick={joinChallengeClick}
                            data-track="click"
                            data-id="nba:membership-hub:challenges:join:cta"
                            data-type="cta"
                            data-text="Join Challenge"
                            data-content={props.challenge.title}
                        >Join Challenge <img src={ArrowRight} /></button>
                    </div>}
                    {showJoinedChallengeNotif && notifBody === props.challenge.id && <ToastNotification title={notif.title} subtitle={notif.subtitle} close={() => dispatch(setShowNotification(false))} />}
                    {challengeLoading && !challengeJoined && <img className="joining-challenge-spinner" src={LoadingGif} alt="" />}
                    <div className={`activities-container${challengeJoined ? " joined" : " not-joined"}`}>
                        {props.challenge && props.challenge.activities && props.challenge.activities.length > 0 ?
                            props.challenge.activities.slice().sort((a,b) => a.activityHistory.length - b.activityHistory.length).map((activity, i) =>
                                {
                                    if (isActivityComplete(activity)) {
                                        return <div className="activity complete" key={i}>
                                            <div className="body">
                                                <div className="check"><img src={BlueCheck} alt="" /></div>
                                                <div className="desc">{activity.activityText}</div>
                                            </div>
                                            {activity.activityCta && activity.activityCta !== "" &&
                                                <div className="cta">
                                                    <div>{activity.activityCta}</div>
                                                </div>
                                            }
                                        </div>;
                                    }

                                    if (activity.activityParent && !isActivityParentComplete(activity)) {
                                        return <div className="activity not-joined" key={i}>
                                            <div className="body">
                                                <div className="check"><img src={ClearCheck} alt="" /></div>
                                                <div className="desc">{activity.activityText}</div>
                                            </div>
                                            {activity.activityCta && activity.activityCta !== "" &&
                                                <div className="cta">
                                                    <div>{activity.activityCta}</div>
                                                </div>
                                            }
                                        </div>;
                                    }

                                    return <div className="activity" key={i}>
                                        <div className="body">
                                            <div className="check"><img src={ClearCheck} alt="" /></div>
                                            <div className="desc">{activity.activityText}</div>
                                        </div>
                                        {activity.activityCta && activity.activityCta !== "" &&
                                            <div className="cta">
                                                { renderActiveCTA(activity) }
                                            </div>
                                        }
                                    </div>
                                }
                            ) : ""
                        }
                    </div>
                    <div className="challenge-reward">
                        <img src={Gift} alt="" />
                        {props.challenge.extra_data.Sweepstake &&
                            <div className="" dangerouslySetInnerHTML={{ __html: props.challenge.extra_data.Sweepstake }}></div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChallengeCard;
